import { render, staticRenderFns } from "./AppMedicalLayout.vue?vue&type=template&id=1caa2b8d&"
import script from "./AppMedicalLayout.vue?vue&type=script&lang=js&"
export * from "./AppMedicalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppMedicalLayout.vue?vue&type=style&index=0&id=1caa2b8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports